import React, { useId, useState } from "react";
import { t } from "ttag";

import { strings } from "../../../localization";

import styles from "./index.module.scss";

/**
 * Paperless (electronic) billing statement disclosure for the Wells Fargo
 * acknowledgement. The first paragraph is always visible; the hardware and
 * software requirements are collapsed behind "Show more".
 */
export const PaperlessStatements = (): React.JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);
    const detailsId = useId();

    return (
        <div className={styles.paperless}>
            <p>{strings.get("FINANCING_PAPERLESS_STATEMENTS")}</p>
            <div id={detailsId} hidden={!isOpen}>
                <p>{strings.get("FINANCING_PAPERLESS_STATEMENTS_DETAILS")}</p>
            </div>
            <button
                type="button"
                className={styles.showMore}
                aria-expanded={isOpen}
                aria-controls={detailsId}
                onClick={() => {
                    setIsOpen(!isOpen);
                }}
            >
                {isOpen ? t`Show less` : t`Show more`}
            </button>
        </div>
    );
};
